<div *ngIf="loaded; else spinner" class="contact-self-service-wrapper"
  [style.backgroundImage]="settings?.background ? 'url(data:image/jpeg;base64,'+  settings?.background +')' : null">
  <div class="form-container">
    <div [ngClass]="settings?.logoPositioning">
      <img *ngIf="settings?.logo" [src]="settings?.logoBase64" alt="Logo" class="logo">
    </div>
    <h1 class="header">{{ 'MAIN.TITLE' | translate }}</h1>
    <div class="content">
      <p
        [innerHtml]="(settings?.defaultContent.length > 0 ? settings?.defaultContent : settings?.emailVerificationContent) | safehtml">
      </p>
    </div>
    <p style="text-align: center;"><label><span style="margin-right: 5px;">{{ 'FIELD.EMAIL.EMAIL_LABEL' | translate
          }}</span></label>{{email}}</p>
    <button class="btn btn-block" (click)="tryAgain()">{{ 'BUTTON.TRY_AGAIN' | translate }}</button>
    <div class="content">
      <p [innerHtml]="settings?.footerContent | safehtml"></p>
    </div>
    <app-footer customFooterClass="landing-email-screen"></app-footer>
  </div>
</div>

<ng-template #spinner>
  <div class="spinner">
    <svg width="40px" height="40px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
      <circle fill="none" stroke-width="4" stroke-linecap="round" cx="33" cy="33" r="30" class="circle"></circle>
    </svg>
  </div>
</ng-template>